<template>
  <div>
    <!-- Change Username Dialog -->
    <v-dialog
      v-model="changeusernameBox"
      max-width="500"
      persistent
    >
      <v-card class="username-dialog-card">
        <v-card-text align="center" class="pt-8 pb-4">
          <LogoWhite></LogoWhite>
        </v-card-text>

        <v-card-text v-if="!changeusernameOK" class="px-6 pb-0">
          <v-form ref="changeUsernameRef" v-model="changeusername" id="change-username-acc-ok">
            <v-text-field
              v-model="usernameNew"
              class="dialog-field"
              :rules="usernameRules"
              label="Enter New Username"
              required
              color="white"
              variant="outlined"
              @focus="checkErrorsRegister()"
              :error-messages="userValidationErrors"
            ></v-text-field>

            <v-text-field
              autocomplete="current-password"
              class="dialog-field mt-4"
              v-model.lazy="passChangeEmail"
              label="Enter Password"
              :append-inner-icon="valueEmail ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append-inner="() => (valueEmail = !valueEmail)"
              :type="valueEmail ? 'password' : 'text'"
              required
              color="white"
              variant="outlined"
              :rules="passwordRulesLogin"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions v-if="!changeusernameOK" class="px-6 pb-6 pt-4">
          <v-btn
            variant="outlined"
            @click="changeusernameBox = false"
            class="dialog-btn"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            form="change-username-acc-ok"
            :disabled="!changeusername"
            variant="outlined"
            class="dialog-btn"
            @click="changeUsernameFun($event)"
          >
            Change Username
          </v-btn>
        </v-card-actions>

        <v-card-text v-if="changeusernameOK" align="center" class="pb-5 pt-4">
          <div class="success-message">
            <v-icon size="48" color="success">mdi-check-circle</v-icon>
            <h3 class="success-title">Success!</h3>
            <p class="success-text">Username changed successfully</p>
          </div>
        </v-card-text>
        <v-card-actions v-if="changeusernameOK" class="px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn
            variant="outlined"
            @click="closeDialogChangeUsername"
            class="dialog-btn"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="pa-0 ma-0">
      <div class="body-overall">
        <v-row style="padding-top:64px!important"></v-row>
        <div :class="getGextPanel" class="pt-6" style="margin:0px!important;">
          <div class="fonts-white container pl-0 pr-1">
            <div class="overlay-grey-web">
              <!-- Header Section -->
              <div class="account-header">
                <div class="header-content">
                  <v-icon class="header-icon">mdi-account-circle</v-icon>
                  <h1 class="header-title">Account Information</h1>
                </div>
                <p class="header-subtitle">
                  Manage your account details and settings
                </p>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Account Details Section -->
              <div v-if="this.user" class="account-section">
                <h2 class="section-title">
                  <v-icon left>mdi-account-details</v-icon>
                  Profile Details
                </h2>

                <div class="info-grid">
                  <!-- Email -->
                  <div class="info-item">
                    <div class="info-label">
                      <v-icon size="20" class="mr-2">mdi-email</v-icon>
                      E-mail Address
                    </div>
                    <v-text-field
                      class="info-field"
                      :model-value="user.email"
                      readonly
                      variant="outlined"
                      density="comfortable"
                      hide-details="auto"
                      hint="Your login, used also as ID for token transfer"
                      persistent-hint
                    ></v-text-field>
                  </div>

                  <!-- Creator Name -->
                  <div class="info-item">
                    <div class="info-label">
                      <v-icon size="20" class="mr-2">mdi-music-circle</v-icon>
                      Creator Name
                    </div>
                    <v-text-field
                      class="info-field"
                      :model-value="user.creator"
                      readonly
                      variant="outlined"
                      density="comfortable"
                      hide-details="auto"
                      hint="MuzE creator unique name"
                      persistent-hint
                    ></v-text-field>
                  </div>

                  <!-- Verse Username -->
                  <div class="info-item">
                    <div class="info-label">
                      <v-icon size="20" class="mr-2">mdi-account</v-icon>
                      Verse Username
                      <v-chip
                        class="ml-2"
                        :color="user.creator_verified === 1 ? 'success' : 'grey'"
                        size="small"
                        variant="flat"
                      >
                        {{ user.creator_verified === 1 ? 'Creator' : 'Listener' }}
                      </v-chip>
                    </div>
                    <div class="info-field-with-action">
                      <v-text-field
                        class="info-field"
                        :model-value="user.verse_username"
                        readonly
                        variant="outlined"
                        density="comfortable"
                        hide-details="auto"
                        hint="Verse unique ID"
                        persistent-hint
                      ></v-text-field>
                      <v-btn
                        variant="outlined"
                        class="action-icon-btn ml-3"
                        @click="handleClickMenu('modifyusername')"
                      >
                        <v-icon>mdi-account-edit</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <!-- Creator Verification -->
                  <div class="info-item">
                    <div class="info-label">
                      <v-icon size="20" class="mr-2">mdi-shield-check</v-icon>
                      Creator Verification
                    </div>
                    <div class="info-field-with-action">
                      <v-text-field
                        class="info-field"
                        :class="{'status-verified': getCreatorVer() === 'Verified', 'status-not-verified': getCreatorVer() === 'Not Verified'}"
                        :model-value="getCreatorVer()"
                        readonly
                        variant="outlined"
                        density="comfortable"
                        hide-details="auto"
                        hint="Verification allows to create artist and link with existing ones"
                        persistent-hint
                      ></v-text-field>
                      <v-btn
                        variant="outlined"
                        class="action-icon-btn ml-3"
                        @click="handleClickMenu('plan')"
                      >
                        <v-icon>mdi-check-decagram</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <!-- Subscription Level -->
                  <div class="info-item">
                    <div class="info-label">
                      <v-icon size="20" class="mr-2">mdi-star</v-icon>
                      Subscription Level
                    </div>
                    <div class="info-field-with-action">
                      <v-text-field
                        class="info-field"
                        :model-value="getLevel(user.level)"
                        readonly
                        variant="outlined"
                        density="comfortable"
                        hide-details="auto"
                        hint="Streaming subscription plan"
                        persistent-hint
                      ></v-text-field>
                      <v-btn
                        variant="outlined"
                        class="action-icon-btn ml-3"
                        @click="handleClickMenu('plan')"
                      >
                        <v-icon>mdi-shopping-outline</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <!-- KYC Status -->
                  <div class="info-item">
                    <div class="info-label">
                      <v-icon size="20" class="mr-2">mdi-card-account-details</v-icon>
                      KYC Verification
                    </div>
                    <div class="info-field-with-action">
                      <v-text-field
                        class="info-field"
                        :class="{'status-verified': getKYC() === 'Verified', 'status-not-verified': getKYC() === 'Not Verified'}"
                        :model-value="getKYC()"
                        readonly
                        variant="outlined"
                        density="comfortable"
                        hide-details="auto"
                        hint="Mandatory for token transfer"
                        persistent-hint
                      ></v-text-field>
                      <v-btn
                        variant="outlined"
                        class="action-icon-btn ml-3"
                        @click="handleClickMenu('settings')"
                      >
                        <v-icon>mdi-card-account-details-outline</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>

              <v-divider class="my-6" style="opacity:0.3;"></v-divider>

              <!-- Wallet Overview Section -->
              <div v-if="this.cryptoUserData" class="wallet-section">
                <h2 class="section-title">
                  <v-icon left>mdi-wallet</v-icon>
                  Wallet Overview
                </h2>

                <div class="wallet-grid">
                  <v-card class="wallet-card">
                    <v-card-text>
                      <div class="wallet-item">
                        <div class="wallet-label">
                          <v-icon size="20" class="mr-2">mdi-coin</v-icon>
                          Total Tokens
                        </div>
                        <div class="wallet-value">{{ formatNumber(cryptoUserData.tokens) }}</div>
                        <div class="wallet-hint">All tokens - including frozen, staked or in transfer</div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card class="wallet-card">
                    <v-card-text>
                      <div class="wallet-item">
                        <div class="wallet-label">
                          <v-icon size="20" class="mr-2">mdi-check-circle</v-icon>
                          Available
                        </div>
                        <div class="wallet-value wallet-value-available">
                          {{ formatNumber(cryptoUserData.tokens - cryptoUserData.tokens_vested - cryptoUserData.in_transfer) }}
                        </div>
                        <div class="wallet-hint">Available tokens - not frozen nor staked or in transfer</div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card class="wallet-card">
                    <v-card-text>
                      <div class="wallet-item">
                        <div class="wallet-label">
                          <v-icon size="20" class="mr-2">mdi-swap-horizontal</v-icon>
                          In Transfer
                        </div>
                        <div class="wallet-value">{{ formatNumber(cryptoUserData.in_transfer) }}</div>
                        <div class="wallet-hint">Tokens in transfer, P2P or in transfer to external Wallet</div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>

              <v-divider class="my-6" style="opacity:0.3;"></v-divider>

              <!-- Market Overview Section -->
              <div v-if="this.p2puser" class="market-section">
                <h2 class="section-title">
                  <v-icon left>mdi-store</v-icon>
                  Your Market
                </h2>

                <div class="market-stats-grid">
                  <!-- Buy Offers -->
                  <v-card class="market-stat-card buy-card">
                    <v-card-text>
                      <div class="market-stat-header">
                        <v-icon size="32" color="success">mdi-cash-plus</v-icon>
                        <div class="market-stat-title">Buy Offers</div>
                      </div>
                      <div class="market-stat-content">
                        <div class="market-stat-main">
                          <span class="market-stat-number">{{ formatNumber(p2puser.buy_requests) }}</span>
                          <span class="market-stat-label">Active Offers</span>
                        </div>
                        <div class="market-stat-detail">
                          <div class="detail-row">
                            <span>Total Tokens:</span>
                            <span class="detail-value">{{ formatNumber(p2puser.total_buy_tokens) }}</span>
                          </div>
                          <div class="detail-row">
                            <span>Total Value:</span>
                            <span class="detail-value">{{ formatNumber(p2puser.total_buy) }}</span>
                          </div>
                          <div class="detail-row">
                            <span>Buying from Market:</span>
                            <span class="detail-value">{{ formatNumber(p2puser.total_market_buy) }}</span>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <!-- Sell Offers -->
                  <v-card class="market-stat-card sell-card">
                    <v-card-text>
                      <div class="market-stat-header">
                        <v-icon size="32" color="error">mdi-cash-minus</v-icon>
                        <div class="market-stat-title">Sell Offers</div>
                      </div>
                      <div class="market-stat-content">
                        <div class="market-stat-main">
                          <span class="market-stat-number">{{ formatNumber(p2puser.sell_requests) }}</span>
                          <span class="market-stat-label">Active Offers</span>
                        </div>
                        <div class="market-stat-detail">
                          <div class="detail-row">
                            <span>Total Tokens:</span>
                            <span class="detail-value">{{ formatNumber(p2puser.total_sell_tokens) }}</span>
                          </div>
                          <div class="detail-row">
                            <span>Total Value:</span>
                            <span class="detail-value">{{ formatNumber(p2puser.total_sell) }}</span>
                          </div>
                          <div class="detail-row">
                            <span>Selling to Market:</span>
                            <span class="detail-value">{{ formatNumber(p2puser.total_market_sell) }}</span>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>

                <!-- Active Offers Lists -->
                <div class="market-offers-section">
                  <!-- Buy Offers List -->
                  <div class="offers-subsection">
                    <h3 class="subsection-title">
                      <v-icon left size="20">mdi-cash-plus</v-icon>
                      Active Buy Offers
                    </h3>
                    <v-card class="offers-card">
                      <v-card-text>
                        <div v-if="p2puseroffers && p2puseroffers.buy_offers == 0" class="empty-state">
                          <v-icon size="48" color="grey">mdi-cash-plus</v-icon>
                          <p class="empty-text">No active buy offers</p>
                        </div>
                        <div v-if="p2puseroffers && p2puseroffers.buy_offers > 0" class="pending-state">
                          <v-icon left color="success">mdi-clock-outline</v-icon>
                          <span>{{ p2puseroffers.buy_offers }} pending offer(s)</span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>

                  <!-- Sell Offers List -->
                  <div class="offers-subsection">
                    <h3 class="subsection-title">
                      <v-icon left size="20">mdi-cash-minus</v-icon>
                      Active Sell Offers
                    </h3>
                    <v-card class="offers-card">
                      <v-card-text>
                        <div v-if="p2puseroffers && p2puseroffers.sell_offers == 0" class="empty-state">
                          <v-icon size="48" color="grey">mdi-cash-minus</v-icon>
                          <p class="empty-text">No active sell offers</p>
                        </div>
                        <div v-if="p2puseroffers && p2puseroffers.sell_offers > 0" class="pending-state">
                          <v-icon left color="error">mdi-clock-outline</v-icon>
                          <span>{{ p2puseroffers.sell_offers }} pending offer(s)</span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <v-row :style="(isMobileXs || isMobilePlayer3) ? 'padding-top:170px!important':'padding-top:128px!important'"></v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { useMobile } from '../composables/useMobile.js'
import { useMobilePlayer3 } from '../composables/useMobilePlayer3.js'
import { useMobileXs } from '../composables/useMobileXs.js'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import LogoWhite from '../components/logo_white.vue';

export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3();

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    return { isMobile, isMobileXs, notify, notifyError, isMobilePlayer3 }
  },
  name: 'Account',

  components: {
    LogoWhite
  },
  data: () => ({
    navbar: false,
    user: null,
    account: null,
    cryptoUserData: null,
    p2puser: null,
    p2puseroffers: null,

    changeusernameBox: false,
    userValidationErrors: [],
    changeusernameOK: false,
    changeusername: false,

    passChangeEmail: '',
    usernameNew: '',
    valueUsername: true,
    value: true,
    valueEmail: true,

  }),
  mounted() {
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {},
  destroyed() {},
  watch: {
    '$store.state.user': function () {
      this.user = this.$store.getters.getUserData;
    },
    '$store.state.crypto_user_data': function () {
      this.cryptoUserData = this.$store.getters.getCryptoUserData;
    },
    '$store.state.p2puser': function () {
      this.p2puser = this.$store.getters.getP2PUser;
    },
    '$store.state.p2puseroffers': function () {
      this.p2puseroffers = this.$store.getters.getP2PUserOffers;
    },
    changeusernameBox() {
      if (this.$refs.changeUsernameRef) {
        this.$refs.changeUsernameRef.resetValidation();
      }
      this.changeusername = false;
      this.passChangeEmail = '';
      this.usernameNew = '';
      this.changeusernameOK = false;
    },
    async usernameNew(val) {
      this.userValidationErrors = ['Checking username..'];
      let resultcheck = val.length >= 3 && val.length <= 30 && /^[a-zA-Z0-9_]*$/.test(val) && !/^_*$/.test(val);
      if (resultcheck) {
        try {
          const res = await this.$store.dispatch('checkUsername', { username: val, creator: this.user.creator_verified });
          if (val !== this.usernameNew) return false

          if (res.data === 0) {
            this.userValidationErrors = ['Username already in use'];
            return false;
          } else {
            this.userValidationErrors = [];
            return true;
          }
        } catch (error) {
          if (!error.response) {
            this.userValidationErrors = ['Service is down.. Try again later!'];
          } else if (error.response.status === 500) {
            this.userValidationErrors = ['Service is down.. Try again later!'];
          } else {
            this.userValidationErrors = ['Username already in use'];
          }
          return false;
        }
      } else {
        this.userValidationErrors = ['Invalid Username'];
        return false;
      }
    },
  },
  computed: {
    usernameRules() {
      return [
        v => {
          var val = !!v
          if (val) {
            return true
          } else {
            this.userValidationErrors = [];
            return 'Username is required'
          }
        },
        v => {
          if (v.length >= 3) {
            return true;
          }
          this.userValidationErrors = [];
          return 'Minimum 3 characters';
        },
        v => {
          if (v.length <= 30) {
            return true;
          }
          this.userValidationErrors = [];
          return 'Maximum 30 characters';
        },
        v => {
          if (/^[a-zA-Z0-9_]*$/.test(v)) {
            return true;
          }
          this.userValidationErrors = [];
          return 'Special characters not allowed';
        },
        v => {
          if (!/^_*$/.test(v)) {
            return true;
          }
          return 'Username cannot contain only underscores';
        }
      ]
    },
    passwordRulesLogin() {
      return [
        v => {
          var vv = !!v
          if (vv) return true;
          else {
            return 'Password is required';
          }
        },
      ]
    },
    isfullScreen() {
      if (this.isMobile && this.isMobileXs) {
        return false;
      } else {
        return true;
      }
    },
    isLogged() {
      return this.$store.getters.getUserData != null
    },
    isDesktop() {
      if (!this.navbar) {
        return true;
      } else {
        return false;
      }
    },
    getGextPanel() {
      if (this.navbar) {
        if (this.isMobileXs) {
          return 'textPanelMobileXs'
        } else {
          return 'textPanelMobile';
        }
      } else return 'textPanel';
    },
  },
  created() {
    if (this.$store.getters.getUserData != null) {
      this.user = this.$store.getters.getUserData;

      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }

      this.emitter.on('changeUsername', () => {
        this.changeusernameBox = true;
        this.userValidationErrors = [];
      })

      this.$store.dispatch('getCryptoUserData', { token: this.user.token
      }).then(response => {
        this.cryptoUserData = this.$store.getters.getCryptoUserData;
      }).catch(error => {
        if (!error.response) {
          this.notifyError("Network problem, please try again later..");
        }
      })

      this.$store.dispatch('getP2PUser').then(response => {
        this.p2puser = this.$store.getters.getP2PUser;
      }).catch(error => {
        if (!error.response) {
          this.notifyError("Network problem, please try again later..");
        }
      })

      this.$store.dispatch('getP2PUserOffers').then(response => {
        this.p2puseroffers = this.$store.getters.getP2PUserOffers;
      }).catch(error => {
        if (!error.response) {
          this.notifyError("Network problem, please try again later..");
        }
      })
    }
  },
  methods: {
    checkErrorsRegister() {
      if (this.userValidationErrors.length != 0
        && (this.userValidationErrors[0] === 'Service is down.. Try again later!')) {
        this.userValidationErrors = [];
      }
    },
    changeUsernameFun(e) {
      this.changeusername = false;
      this.passChangeEmail = this.passChangeEmail.trim();
      this.usernameNew = this.usernameNew.trim();

      this.$store.dispatch('changeusername', { pass: this.passChangeEmail, token: this.user.token, uid: this.user.uid, newusername: this.usernameNew }).then(response => {
        this.user = this.$store.getters.getUserData;
        this.changeusernameOK = true;
        this.notify('Username changed successfully');
      }).catch(error => {
        this.changeusername = false;
        this.passChangeEmail = '';
        this.usernameNew = '';
        this.notifyError("Error username change. Please try again later.");
      })
    },
    closeDialogChangeUsername() {
      this.changeusernameBox = false;
      this.changeusernameOK = false;
    },
    formatNumber(number) {
      let integer = parseInt(number);

      if (number == integer)
        return number;
      else {
        return parseFloat(number).toFixed(6).replace(/\.?0+$/, '');
      }
    },
    getLevel(lvl) {
      if (lvl == 0) {
        return 'Free'
      } else if (lvl === 1) {
        return 'Premium'
      } else {
        return 'Max'
      }
    },
    getCreatorVer() {
      if (this.user.creator_verified === 1) {
        return 'Verified'
      } else {
        return 'Not Verified'
      }
    },
    getKYC() {
      if (this.user.kyc === 0 && this.user.kyc_corp === 0) {
        return 'Not Verified'
      } else {
        return 'Verified'
      }
    },
    checkScreenSize() {
      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    },
    handleClickMenu(link) {
      if (link === 'TryMuzE') {
        window.location.href = 'https://muze.muzible.com/';
      } else if (link === 'TryVerse') {
        window.location.href = 'https://verse.muzible.com/';
      } else if (link === 'modifyusername') {
        this.emitter.emit('changeUsername');
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* Account Header */
.account-header {
  margin-bottom: 24px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.header-icon {
  font-size: 48px !important;
  color: white;
}

.header-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.header-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 20px 0;
  line-height: 1.5;
}

/* Section Title */
.section-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.subsection-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: white;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Account Section */
.account-section {
  margin-bottom: 32px;
  animation: slideIn 0.4s ease forwards;
}

.info-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-label {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: white;
  display: flex;
  align-items: center;
}

.info-field {
  font-family: "Darker Grotesque", sans-serif !important;

  :deep(.v-field) {
    background: rgba(255, 255, 255, 0.05) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-radius: 8px !important;
  }

  :deep(.v-field__input) {
    color: white !important;
    font-family: "Darker Grotesque", sans-serif !important;
    font-size: 15px !important;
    font-weight: 500;
  }

  :deep(.v-field--disabled) {
    opacity: 1;
  }

  :deep(.v-messages) {
    color: rgba(255, 255, 255, 0.6) !important;
    font-family: "Darker Grotesque", sans-serif !important;
    font-size: 13px !important;
  }
}

.info-field.status-verified {
  :deep(.v-field) {
    border-color: rgba(76, 175, 80, 0.5) !important;
  }

  :deep(.v-field__input) {
    color: #4caf50 !important;
  }
}

.info-field.status-not-verified {
  :deep(.v-field) {
    border-color: rgba(226, 71, 75, 0.5) !important;
  }

  :deep(.v-field__input) {
    color: #e2474b !important;
  }
}

.info-field-with-action {
  display: flex;
  align-items: flex-start;
  gap: 12px;

  .info-field {
    flex: 1;
  }
}

.action-icon-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  min-width: 48px !important;
  height: 40px !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  transition: all 0.2s;
  margin-top: 0;
}

.action-icon-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

/* Wallet Section */
.wallet-section {
  margin-bottom: 32px;
  animation: slideIn 0.4s ease forwards;
}

.wallet-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.wallet-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  transition: all 0.3s ease;
  padding: 8px;
}

.wallet-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.wallet-item {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.wallet-label {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
}

.wallet-value {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: white;
}

.wallet-value-available {
  color: #4caf50;
}

.wallet-hint {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.4;
}

/* Market Section */
.market-section {
  margin-bottom: 32px;
  animation: slideIn 0.4s ease forwards;
}

.market-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.market-stat-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  transition: all 0.3s ease;
  padding: 8px;
}

.market-stat-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.buy-card:hover {
  border-color: rgba(76, 175, 80, 0.5);
}

.sell-card:hover {
  border-color: rgba(226, 71, 75, 0.5);
}

.market-stat-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.market-stat-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 22px;
  font-weight: 600;
  color: white;
}

.market-stat-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.market-stat-main {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.market-stat-number {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 36px;
  font-weight: 700;
  color: white;
}

.market-stat-label {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.market-stat-detail {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: "Darker Grotesque", sans-serif;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

.detail-value {
  font-weight: 600;
  color: white;
}

/* Market Offers */
.market-offers-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.offers-subsection {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.offers-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding:8px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}

.empty-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 12px;
}

.pending-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-family: "Darker Grotesque", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: white;
  gap: 8px;
}

/* Username Dialog */
.username-dialog-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.98), rgba(18, 18, 18, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
}

.dialog-field {
  font-family: "Darker Grotesque", sans-serif !important;

  :deep(.v-field) {
    background: rgba(255, 255, 255, 0.05) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-radius: 8px !important;
  }

  :deep(.v-field__input) {
    color: white !important;
    font-family: "Darker Grotesque", sans-serif !important;
    font-size: 15px !important;
  }

  :deep(.v-label) {
    color: rgba(255, 255, 255, 0.7) !important;
    font-family: "Darker Grotesque", sans-serif !important;
  }
}

.dialog-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.dialog-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.success-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.success-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}

/* Animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .header-title {
    font-size: 32px;
  }

  .wallet-grid,
  .market-stats-grid,
  .market-offers-section {
    grid-template-columns: 1fr;
  }

  .info-field-with-action {
    flex-direction: column;

    .info-field {
      width: 100%;
    }

    .action-icon-btn {
      width: 95%;
    }
  }
}

/* Override Vuetify */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-list-item:hover) > .v-list-item__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-chip) {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 600 !important;
}
</style>